const translations = {
  de_DE: {
    errorMessage: 'Die von Ihnen aufgerufene Seite existiert nicht.',
    headerMessage: 'Sieht so aus, als hätten Sie sich verlaufen.',
    linkLabel: 'Zu COMPEON',
  },
}

export default translations
